// ProviThor Chat Widget – öffnet /apps/chat im Panel (fresh locale, no SVG)

(function(){
  // ---------- helpers ----------
  function _qs(s,r=document){ return r.querySelector(s); }
  function _two(s){ return String(s||'en').toLowerCase().replace('_','-').split('-')[0]; }
  function _cookie(name){
    const m = document.cookie.match(new RegExp('(?:^|; )'+name.replace(/[-.[\]{}()*+?^$|\\]/g,'\\$&')+'=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function _firstPathLocale(path){
    const seg = String(path || location.pathname).replace(/^\/+/, '').split('/')[0] || '';
    if (!seg || seg.toLowerCase()==='apps') return '';                     // /apps/... ist KEIN Locale
    if (/^[a-z]{2}(?:-[a-z]{2})?$/i.test(seg)) return _two(seg);
    return '';
  }

  // ---------- Locale nur LESEN, nichts am DOM ändern ----------
  function _detectLocale(){
    // 1) URL-Prefix (Shopify Routings) – am zuverlässigsten
    const lcFromRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) ? _firstPathLocale(Shopify.routes.root) : '';
    const lcFromPath = _firstPathLocale(location.pathname);

    // 2) <html lang>
    const htmlLang   = document.documentElement.getAttribute('lang') || '';

    // 3) Transcy (häufige Cookie-Namen; nur lesen)
    const tc = _cookie('transcy_language')
            || _cookie('transcy-lang')
            || _cookie('tc_selected_lang')
            || _cookie('tc-lang')
            || _cookie('tcly');

    // 4) Shopify / Browser
    const shopifyLC  = (window.Shopify && Shopify.locale) || '';
    const browserLC  = navigator.language || 'en';

    return _two(lcFromRoot || lcFromPath || htmlLang || tc || shopifyLC || browserLC);
  }

  // Immer frisch bauen – kein Caching
  function _buildUrl(){
    const lc = _detectLocale();
    return `/apps/chat/lc/${encodeURIComponent(lc)}?v=${Date.now().toString().slice(0,10)}`;
  }

  // ---------- UI ----------
  function _ensureDom(){
    if (_qs('#pvth-chat-launcher')) return;

    // Launcher (ohne SVG, simples Text-Icon)
    const btn = document.createElement('button');
    btn.id = 'pvth-chat-launcher';
    btn.type = 'button';
    btn.setAttribute('aria-label','Support öffnen');
    btn.textContent = '💬';
    document.body.appendChild(btn);

    // Overlay
    const overlay = document.createElement('div');
    overlay.id = 'pvth-chat-overlay';
    overlay.setAttribute('aria-hidden','true');
    document.body.appendChild(overlay);

    // Panel
    const panel = document.createElement('div');
    panel.id = 'pvth-chat-panel';
    panel.innerHTML = `
      <div id="pvth-chat-head">
        <div class="title">Support</div>
        <button id="pvth-chat-close" aria-label="Schließen" title="Schließen" type="button">×</button>
      </div>
      <iframe id="pvth-chat-frame" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    `;
    document.body.appendChild(panel);

    window.addEventListener('message', (e) => {
  if (e?.data?.type !== 'PVTH_CHAT_SESSION_EXPIRED') return;
  const f = document.querySelector('#pvth-chat-frame');
  if (f) {
    // falls du _buildUrl() im Widget hast:
    if (typeof _buildUrl === 'function') f.src = _buildUrl();
    else f.src = '/apps/chat?v=' + Date.now(); // Fallback
  }
}, false);


    function open(){
      overlay.style.display='block';
      panel.style.display='block';
      overlay.setAttribute('aria-hidden','false');

      // ⬇️ JEDES Öffnen: frische Locale auslesen
      const f = _qs('#pvth-chat-frame');
      if (f) f.src = _buildUrl();
    }
    function close(){
      overlay.style.display='none';
      panel.style.display='none';
      overlay.setAttribute('aria-hidden','true');
    }

    btn.addEventListener('click', open);
    overlay.addEventListener('click', close);
    _qs('#pvth-chat-close', panel).addEventListener('click', close);

    // optional: auto-open via ?chat=open
    try{ if(new URLSearchParams(location.search).get('chat')==='open') open(); }catch{}
  }

  // ---------- Live-Änderungen beobachten (nur wenn offen) ----------
  function _startLocaleWatcher(){
    const refresh = () => {
      const f = _qs('#pvth-chat-frame');
      const visible = _qs('#pvth-chat-panel')?.style.display !== 'none';
      if (!f || !visible) return;
      const fresh = _buildUrl();
      // nur neu setzen, wenn sich der Pfad (ohne Cachebuster) ändert
      const curBase = f.src.split('?')[0];
      const nextBase = (location.origin + fresh).split('?')[0];
      if (curBase !== nextBase) f.src = fresh;
    };
    new MutationObserver(refresh)
      .observe(document.documentElement, { attributes:true, attributeFilter:['lang'] });
    setInterval(refresh, 2000); // Fallback, wenn nur Cookie wechselt
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', ()=>{ _ensureDom(); _startLocaleWatcher(); });
  } else {
    _ensureDom(); _startLocaleWatcher();
  }
})();
